import { useState } from 'react'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import { useExtraModalStore, useModalStore } from 'src/stores/ModalStore'
import styled from 'styled-components'
import { CommonButton, NextButton } from '../common/CommonStyled'
import { deleteTeam } from 'src/api/Admin'
import { LoadTeam } from './useLoadTeam'

const TitleWrapper = styled.div`
    font-size: 24px;
    font-weight: 600;
    text-align: left;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top:24px;
`

const ExtraModalDeleteCheck = () => {
    const selectedTeam = useAdTeamStore((state)=>state.selectedTeam)
    const setField = useExtraModalStore((state)=>state.setField)
    const modalsetField = useModalStore((state)=>state.setField)
    const [succcess,setSuccess] = useState(false)

    const onClickDelete = async ()=>{
        const response = await deleteTeam(selectedTeam?.team_id ?? 0)
        if(response?.status === 200){
            LoadTeam()
            setSuccess(true)
        }
    }

    const onClickCheck = ()=>{
        setField('open',false)
        modalsetField('open',false)
    }

    return (
        <>
        {succcess ? 
            <>
                <TitleWrapper>
                    삭제되었습니다.
                </TitleWrapper>
                <ButtonWrapper>
                    <NextButton style={{maxWidth:'68px', maxHeight:'40px'}} onClick={onClickCheck}>확인</NextButton>
                </ButtonWrapper>
            </>
        :
        <>
            <TitleWrapper>
                '{selectedTeam?.team_name}' 팀을 삭제하시겠습니까?
            </TitleWrapper>
            <div style={{ marginTop: '12px' }}>
            삭제 후에는 복구가 불가합니다.
            </div>
            <ButtonWrapper>
                <CommonButton style={{maxWidth:'68px', maxHeight:'40px', border:'1px solid #767676', backgroundColor:'#E3E3E3', color:'#1E1E1E'}} onClick={()=>setField('open',false)}>취소</CommonButton>
                <NextButton style={{maxWidth:'68px', maxHeight:'40px'}} onClick={onClickDelete}>확인</NextButton>
            </ButtonWrapper>
        </>
        }
        </>
    )
}

export default ExtraModalDeleteCheck